import { styled } from '@mui/material/styles';

export const StyledRoot = styled('div')({
  position: 'absolute',
  top: '-2px',
  left: '-5px',
});
